import { render } from "./AdminBoardMembers.vue?vue&type=template&id=bd3c5f7c&scoped=true"
import script from "./AdminBoardMembers.vue?vue&type=script&lang=js"
export * from "./AdminBoardMembers.vue?vue&type=script&lang=js"

import "./AdminBoardMembers.vue?vue&type=style&index=0&id=bd3c5f7c&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd3c5f7c"]])

export default __exports__